<template>
  <div>
    <b-row>
      <b-col class="text-center">
        <b-img
          v-if="imgURL"
          v-bind="mainProps"
          :src="imgURL"
          rounded
          :alt="`${title} logo`"
        />
        <image-upload
          v-else
          ref="image-upload"
          text-drag="Upload or Drag Session Cover Photo (.png, .jpg)"
          :img-upload-idx="idx"
          img-upload-type="sessions"
          :storage-path="storagePath"
          :max-image="1"
          :show-edit="false"
          :show-delete="false"
          style="height:90%;width:90%"
          @img-uploaded-url="handleImgUploadedURL"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <!-- TITLE -->
        <b-form-group>
          <label-info
            id="session-title"
            label-name="Title"
            label-info=""
            :is-required="true"
          />
          <b-form-input
            type="text"
            required
            v-model="title"
            @input="handleValueChange('title', title)"
            placeholder="My Session"
          />
        </b-form-group>
        <!-- TOPIC -->
        <b-form-group>
          <label-info id="session-subtitle" label-name="Topic" label-info="" />
          <b-form-input
            type="text"
            required
            v-model="topic"
            @change="handleValueChange('topic', topic)"
          />
        </b-form-group>
        <!-- DATE -->
        <div class="overlay" v-if="calendar" @click="calendar = false" />
        <div class="form-group birthday_input">
          <b-form-group
            label="Session Date"
            label-for="input-2"
            class="custom-label"
            id="icon"
          >
            <b-input-group>
              <b-form-input
                id="input-2"
                v-model.trim="session_date_at"
                trim
                @click="handleCalendarFocusClick(true)"
                @focus="handleCalendarFocusClick(true)"
                @blur="handleCalendarFocusClick(false)"
                class="custom-input"
                placeholder="Session Date"
                type="text"
              >
              </b-form-input>

              <b-input-group-append>
                <span>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.16669 4.16634C3.70645 4.16634 3.33335 4.53944 3.33335 4.99967V16.6663C3.33335 17.1266 3.70645 17.4997 4.16669 17.4997H15.8334C16.2936 17.4997 16.6667 17.1266 16.6667 16.6663V4.99967C16.6667 4.53944 16.2936 4.16634 15.8334 4.16634H4.16669ZM1.66669 4.99967C1.66669 3.61896 2.78598 2.49967 4.16669 2.49967H15.8334C17.2141 2.49967 18.3334 3.61896 18.3334 4.99967V16.6663C18.3334 18.0471 17.2141 19.1663 15.8334 19.1663H4.16669C2.78598 19.1663 1.66669 18.0471 1.66669 16.6663V4.99967Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.3334 0.833008C13.7936 0.833008 14.1667 1.2061 14.1667 1.66634V4.99967C14.1667 5.45991 13.7936 5.83301 13.3334 5.83301C12.8731 5.83301 12.5 5.45991 12.5 4.99967V1.66634C12.5 1.2061 12.8731 0.833008 13.3334 0.833008Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6.66669 0.833008C7.12692 0.833008 7.50002 1.2061 7.50002 1.66634V4.99967C7.50002 5.45991 7.12692 5.83301 6.66669 5.83301C6.20645 5.83301 5.83335 5.45991 5.83335 4.99967V1.66634C5.83335 1.2061 6.20645 0.833008 6.66669 0.833008Z"
                      fill="#B3C2CB"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.66669 8.33301C1.66669 7.87277 2.03978 7.49967 2.50002 7.49967H17.5C17.9603 7.49967 18.3334 7.87277 18.3334 8.33301C18.3334 8.79324 17.9603 9.16634 17.5 9.16634H2.50002C2.03978 9.16634 1.66669 8.79324 1.66669 8.33301Z"
                      fill="#B3C2CB"
                    />
                  </svg>
                </span>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <div class="session-calendar-wrapper">
            <b-calendar
              id="birthday_calender"
              v-if="calendar"
              v-model="session_date_at"
              @context="onContext"
              :hide-header="true"
              selected-variant="warning"
              block
              today-variant="info"
              :date-format-options="{
                year: 'numeric',
                month: 'long',
                day: '2-digit',
                weekday: 'short'
              }"
              :min="calendarMin"
              :max="calendarMax"
              @selected="handleCalendarDateSelected"
              locale="en-US"
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <!---DURATION -->
    <b-row>
      <b-col>
        <b-form-group>
          <label-info
            id="session-duration-hours"
            label-name="Hours"
            label-info=""
            :is-required="true"
          />
          <b-form-spinbutton
            id="sb-vertical"
            v-model="duration_hr"
            :min="0"
            :max="3"
            @change="handleValueChange('duration_hr', duration_hr)"
            :vertical="verticalSpinDur"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group>
          <label-info
            id="session-duration-minutes"
            label-name="Minutes"
            label-info=""
            :is-required="true"
          />
          <b-form-spinbutton
            id="sb-vertical"
            v-model="duration_min"
            :min="15"
            :max="59"
            :step="15"
            @change="handleValueChange('duration_min', duration_min)"
            :vertical="verticalSpinDur"
          />
        </b-form-group>
      </b-col>
    </b-row>

    <!--- DESCRIPTION  -->
    <b-form-group>
      <label-info
        id="session-description"
        label-name="Description"
        label-info=""
        :is-required="true"
      />
      <transition name="fadeHeight" mode="out-in">
        <Editor
          id="textarea-default"
          v-show="true"
          @input="input"
          :clear="clear"
          :content="description"
          @resetClear="resetClear"
        />
      </transition>
    </b-form-group>
    <pre v-if="!production" class="small">{{ context }}</pre>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/common/labelInfo";
import Editor from "@/components/common/editor";
import UploadImage from "@/mixins/UploadImage";
import ImageUpload from "@/components/common/imageUpload";
export default {
  name: "AddEditSession_GeneralInfo",
  mixins: [UploadImage],
  components: {
    LabelInfo,
    Editor,
    ImageUpload
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      }
    },
    storagePath: {
      type: String,
      default: "sessions_session_img"
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
    imgURL() {
      debugger;
      return this.form && this.form.imgURL ? this.form.imgURL : null;
    }
  },
  methods: {
    handleImgUploadedURL(idx, url) {
      debugger;
      this.handleValueChange("imgURL", url);
    },
    handleValueChange(key, value) {
      //mixin
      this.$emit("value-change", { key: key, value: value });
    },
    input(val) {
      this.$emit("value-change", { key: "description", value: val.content });
    },
    resetClear() {
      this.clear = false;
    },
    onContext(ctx) {
      this.context = ctx;
      // this.session_date_at = ctx.activeFormatted;
      //
    },
    validationStatus(validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    handleCalendarDateSelected(date) {
      this.$emit("value-change", { key: "session_date_at", value: date });
    },
    handleCalendarFocusClick(isFocused) {
      this.calendar = isFocused;
    }
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);

    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 2);
    maxDate.setDate(15);
    return {
      idx: 0,
      production: true,
      verticalSpinDur: false,
      clear: false,
      calendar: false,
      context: null,
      calendarMin: minDate,
      calendarMax: maxDate,
      title: this.form && this.form.title ? this.form.title : null,
      topic: this.form && this.form.topic ? this.form.topic : null,
      duration_hr:
        this.form && this.form.duration_hr ? this.form.duration_hr : null,
      duration_min:
        this.form && this.form.duration_min ? this.form.duration_min : 15,
      session_date_at:
        this.form && this.form.session_date_at
          ? this.form.session_date_at
          : null,
      description:
        this.form && this.form.description ? this.form.description : null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 200,
        height: 200,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>
